import Vue from 'vue'
import App from '@/App.vue'

import router from '@/router'
import store from '@/store'

// libs
import axios from 'axios'
import VeeValidate from 'vee-validate'
import _debounce from 'lodash/debounce'

import '@/registerServiceWorker'
import '@/assets/sass/style.scss'
import swal from 'sweetalert2/dist/sweetalert2.js'

// filters
import FormatDate from '@/assets/js/filters/FormatDate'

// mixins
import Querify from '@/assets/js/mixins/base/Querify'
import Query from '@/assets/js/mixins/base/Query'
import Message from '@/assets/js/mixins/ws/Message'
import Transfer from '@/assets/js/mixins/ws/Transfer'
import User from '@/assets/js/mixins/ws/User'
import Boards from '@/assets/js/mixins/ws/Boards'
import Bets from '@/assets/js/mixins/ws/Bets'
import Points from '@/assets/js/mixins/ws/Points'
import NumberGenerator from '@/assets/js/mixins/base/NumberGenerator'
import { translate } from '@/assets/js/translations/Translate'

Vue.use(VeeValidate)
Vue.config.productionTip = false

const swalPlugin = {}
swalPlugin.install = (Vue) => {
  Vue.prototype.$swal = swal
}

Vue.use(swalPlugin)

String.prototype.replaceAll = function (search, replacement) {
  const target = this
  return target.replace(/,/g, replacement)
}

//= axios default configurations
axios.defaults.baseURL = process.env.VUE_APP_API_URL || 'http://localhost:4000'

axios.defaults
  .headers
  .common.Authorization = `Bearer ${window.localStorage.token}`

//= request interceptor, if the resource responds with 401, then redirect
axios.interceptors.response.use((config) => { return config }, (err) => {
  if (err.response.status === 401) {
    window.localStorage.clear()
    router.push('/login')
  }

  return Promise.reject(err)
})

Vue.mixin(FormatDate)
Vue.mixin(Querify)
Vue.mixin(Query)
Vue.mixin(NumberGenerator)
Vue.mixin(translate)

new Vue({
  router,
  store,
  mixins: [Message, Transfer, User, Boards, Bets, Points],

  async mounted () {
    if (window.localStorage.getItem('token')) {
      window.addEventListener('click', this.revalidate)
    }
  },

  watch: {
    $route (to) {
      if (['logout-page', 'login-page'].includes(to.name)) {
        window.removeEventListener('click', this.revalidate)
      } else {
        console.log(to.name)
        window.addEventListener('click', this.revalidate)
      }
    }
  },

  methods: {
    revalidate: _debounce(async function () {
      if (['logout-page', 'login-page'].includes(this.$route.name)) {
        return
      }

      try {
        const response = await axios.post('/admins/revalidate', {
          page: this.$route.name
        })

        window.localStorage.setItem('token', response ? response.data : '')
        axios.defaults.headers.common.Authorization = `Bearer ${window.localStorage.getItem('token')}`
      } catch (error) {
        console.log(error)
      }
    }, 1000)
  },

  render: h => h(App)
}).$mount('#app')
